"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputHtmlImageDialog = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const icons_1 = require("@material-ui/icons");
const useFilterImageAttachments_1 = require("./useFilterImageAttachments");
const useProxyUrl_1 = require("./useProxyUrl");
const StyledDialogTitle = (0, styled_components_1.default)(core_1.DialogTitle) `
  display: flex;
  align-items: center;
  .MuiSvgIcon-root {
    margin-right: 10px;
  }
`;
const StyledTableContainer = (0, styled_components_1.default)(core_1.TableContainer) `
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
  border: 1px solid #ccc;
`;
const InputHtmlImageDialog = props => {
    const { open, uploader, attachments, proxyOptions, onCancel, onSelect, onCompleteUpload, onChangeAttachments } = props;
    const onSelectRef = (0, react_1.useRef)(onSelect);
    onSelectRef.current = onSelect;
    const fileInputRef = (0, react_1.useRef)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const onSelectStorageKey = (0, react_1.useCallback)((storageKey) => {
        if (!onSelectRef.current) {
            return;
        }
        const url = (0, useProxyUrl_1.createProxyUrl)(storageKey || '', proxyOptions, undefined, true);
        onSelectRef.current(url.toString());
    }, [proxyOptions]);
    const handleFiles = (files) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!uploader) {
            return;
        }
        // upload files
        setIsLoading(true);
        const uploadFiles = yield uploader.uploadAsync(Array.from(files));
        setIsLoading(false);
        // map uploaded results
        const value = uploadFiles.map(item => {
            var _a, _b;
            return {
                url: (_a = item.presignedUrl) === null || _a === void 0 ? void 0 : _a.storageKey,
                signedUrl: (_b = item.presignedUrl) === null || _b === void 0 ? void 0 : _b.signedUrl,
                name: item.file.name,
                size: item.file.size
            };
        });
        // remove any duplicate files from current attachments
        value.push(...attachments.filter(value => {
            return !uploadFiles.some(uploadFile => value.name === uploadFile.file.name);
        }));
        for (const uploadFile of uploadFiles) {
            onSelectStorageKey((_a = uploadFile.presignedUrl) === null || _a === void 0 ? void 0 : _a.storageKey);
        }
        onChangeAttachments === null || onChangeAttachments === void 0 ? void 0 : onChangeAttachments(value);
        onCompleteUpload === null || onCompleteUpload === void 0 ? void 0 : onCompleteUpload();
    });
    const imageAttachments = (0, useFilterImageAttachments_1.useFilterImageAttachments)(attachments);
    return (react_1.default.createElement(core_1.Dialog, { open: open, onClose: onCancel },
        isLoading && react_1.default.createElement(core_1.LinearProgress, null),
        react_1.default.createElement(StyledDialogTitle, { disableTypography: true },
            react_1.default.createElement(icons_1.AddPhotoAlternate, null),
            react_1.default.createElement(core_1.Typography, { variant: 'h6' }, "Attach image or use existing image")),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(lab_1.Alert, { severity: 'info' }, "Upload a new image or use an existing image to attach"),
            react_1.default.createElement(StyledTableContainer, null,
                react_1.default.createElement(core_1.Table, null,
                    react_1.default.createElement(core_1.TableHead, null,
                        react_1.default.createElement(core_1.TableRow, null,
                            react_1.default.createElement(core_1.TableCell, null, "File Name"),
                            react_1.default.createElement(core_1.TableCell, null, "Attach"))),
                    react_1.default.createElement(core_1.TableBody, null,
                        !imageAttachments.length && (react_1.default.createElement(core_1.TableRow, null,
                            react_1.default.createElement(core_1.TableCell, { colSpan: 2 }, "No image attachments."))),
                        imageAttachments.map((attachment, index) => (react_1.default.createElement(core_1.TableRow, { key: index },
                            react_1.default.createElement(core_1.TableCell, null, (attachment === null || attachment === void 0 ? void 0 : attachment.name) || ''),
                            react_1.default.createElement(core_1.TableCell, null,
                                react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'outlined', disabled: isLoading, onClick: () => onSelect === null || onSelect === void 0 ? void 0 : onSelect(attachment.url) }, "Use"))))))))),
        react_1.default.createElement(core_1.Divider, null),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', disabled: isLoading, endIcon: isLoading ? (react_1.default.createElement(core_1.CircularProgress, { color: 'primary', size: 20 })) : (react_1.default.createElement(icons_1.AddPhotoAlternate, null)), onClick: () => { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, "Upload new image"),
            react_1.default.createElement("input", { hidden: true, type: 'file', ref: fileInputRef, 
                // accept={InputAcceptType.Images}
                accept: 'image/*,.jpeg,.jpg,.png,.gif', onChange: (event) => __awaiter(void 0, void 0, void 0, function* () {
                    const files = event === null || event === void 0 ? void 0 : event.target.files;
                    if (uploader && files && files.length > 0) {
                        handleFiles(Array.from(files));
                    }
                    // clear input field
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                }) }))));
};
exports.InputHtmlImageDialog = InputHtmlImageDialog;
exports.default = exports.InputHtmlImageDialog;
//# sourceMappingURL=InputHtmlImageDialog.js.map